import { render, staticRenderFns } from "./fill-info.vue?vue&type=template&id=524c3a5e&scoped=true&"
import script from "./fill-info.vue?vue&type=script&lang=js&"
export * from "./fill-info.vue?vue&type=script&lang=js&"
import style0 from "./fill-info.vue?vue&type=style&index=0&id=524c3a5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524c3a5e",
  null
  
)

export default component.exports